export default __webpack_public_path__ + "static/media/komal2.913f8de6.png";